import {
    escapePrintViewText,
    replaceMediaLikeTagsWithIds,
} from '@/common/questionPrintView/shared'

const buildFillInTheBlankQuestionPrintView = (content) => {
    const questionHtml = replaceMediaLikeTagsWithIds(content.question || '')
    const template = document.createElement('template')
    template.innerHTML = questionHtml

    template.content.querySelectorAll('blank').forEach((blankElement) => {
        const blankId = escapePrintViewText(blankElement.getAttribute('blank_id') || '')
        blankElement.replaceWith(`[Blank ${blankId}]`)
    })

    const blanksHtml = (content.blanks || [])
        .map((blank) => {
            const blankId = escapePrintViewText(blank.blank_id || '')

            if (blank.is_open_response) {
                return `<p>Blank ${blankId}: open response</p>`
            }

            const optionsHtml = (blank.options || [])
                .map((option) => {
                    const optionText = escapePrintViewText(option.option || '')

                    if (!optionText) {
                        return ''
                    }

                    return `<p>${optionText}</p>`
                })
                .filter(Boolean)
                .join('')

            if (!optionsHtml) {
                return ''
            }

            return `<p>&nbsp;</p><p>Blank ${blankId} Options:</p>${optionsHtml}`
        })
        .filter(Boolean)
        .join('')

    return `${template.innerHTML}${blanksHtml}`
}

export {buildFillInTheBlankQuestionPrintView}
